export default defineNuxtRouteMiddleware((to, from) => {
  // console.log("FROM 222", event.node.req);
  // if (to.path !== "/" && !to.path.endsWith("/")) {
  //   const { path, query, hash } = to;
  //   const nextPath = path + "/";
  //   const nextRoute = { path: nextPath, query, hash };
  //   return navigateTo(nextRoute, { redirectCode: 301 });
  // }
});
